import React from 'react'
import styled from 'styled-components'

import Activity from './Activity'

export default ({ title, subtitle, activities }) => (
  <Container>
    <SectionHeader>
      <Title>{title}</Title>
      <Subtitle>{subtitle}</Subtitle>
    </SectionHeader>
    <ActivitiesList>
      {activities.map((activity, i) => <Activity key={i} {...activity} />)}
    </ActivitiesList>
  </Container>
)
const Container = styled.section`
  background-color: #efefef;

  &:nth-of-type(even) {
    background-color: white;
  }
`
const SectionHeader = styled.div`
  max-width: 1000px;
  padding: 30px;
  margin: 0 auto;
`
const Title = styled.h1`
  font-family: ${props => props.theme.mainFont};
  font-weight: ${props => props.theme.bold};
  font-size: 27px;
  color: ${props => props.theme.mainColor};
  text-transform: uppercase;
  margin-bottom: 15px;
`
const Subtitle = styled.h2`
  font-size: 18px;
  line-height: 26px;
  color: ${props => props.theme.fontColor};
  font-family: ${props => props.theme.secondaryFont};
  font-weight: ${props => props.theme.regular};
`
const ActivitiesList = styled.div`
  max-width: 1000px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
  margin: 0 auto;
`
